
export default {
  name: 'ProductListingSectionHeaderWrapper',

  props: {
    data: {
      type: Object,
      default: () => {}
    },
    anchorLink: {
      type: String,
      default: '#'
    },
    showQuickGuide: {
      type: Boolean,
      default: true
    },
    filterSum: {
      type: Number,
      default: 0
    }
  },
  mounted() {
    this.$nextTick(() => {
      const filterBar = document.getElementsByClassName("sticky-filter")[0];
      const mobileFilterBar = document.getElementsByClassName("mobile-filter-wrapper")[0];
      // console.log(filterBar)
      // console.log(mobileFilterBar)
      // const sticky = filterBar.offsetTop;
      window.addEventListener('scroll', () => {
        if (window.scrollY >= 400) {
          // console.log(window.scrollY)
          // console.log(sticky)
          filterBar.style.position = "fixed";
          filterBar.style.top = "0";
          filterBar.style.width = "100%";
          filterBar.style.transition = "top 0.3s";
          filterBar.style.display = "flex";



          mobileFilterBar.style.position = "fixed";
          mobileFilterBar.style.top = "0";
          mobileFilterBar.style.width = "";
          mobileFilterBar.style.transition = "top 0.3s"

          // mobileFilterBar.style.position = "relative";
          // mobileFilterBar.style.top = "";
          // mobileFilterBar.style.transition = "top 0.3s"

        } else if (window.scrollY <= 400){
          filterBar.style.position = "";
          filterBar.style.top = "";
          filterBar.style.width = "";
          filterBar.style.display = "none"

          mobileFilterBar.style.position = "relative";
          mobileFilterBar.style.top = "";
          mobileFilterBar.style.transition = "top 0.3s"


        }
      })
      // window.onscroll = () => {
      //   if (window.scrollY >= sticky) {
      //     console.log(window.scrollY)
      //     console.log(sticky)
      //     filterBar.style.position = "fixed";
      //     filterBar.style.top = "0";
      //     filterBar.style.width = "100%";
      //   } else {
      //     filterBar.style.position = "";
      //     filterBar.style.top = "";
      //     filterBar.style.width = "";
      //   }
      // }
    })
  },
  methods: {
    handleClickOpenModal() {
      this.$store.commit('modal/setDisplayMobileFilter', {isOpen: true, mode: '-'})
    }
  }
};
